export interface RelativeCaptionSettings {
    /**
     * Enable/Disable relative captions
     */
    relativeCaption: boolean;
}

export const relativeCaptionSettings: RelativeCaptionSettings = {
    relativeCaption: false,
};
